import * as z from "zod";
import type {
  OperationsSettingsPatch,
  ReturnsOperationsSettingsSource,
} from "./operations-settings-source";

export const pointOfSaleSettingsShape = {
  pointOfSale: z.object({
    restockByDefault: z.boolean(),
    sendOnlyCompletionEmail: z.boolean(),
    allowAdjustments: z.boolean(),
    allowManualDiscounts: z.boolean(),
  }),
};

export type PointOfSaleSettings = z.infer<
  z.ZodObject<typeof pointOfSaleSettingsShape>
>;

export function pointOfSaleSettingsFromTeam({
  settings,
}: ReturnsOperationsSettingsSource): PointOfSaleSettings {
  const { pos } = settings;
  return {
    pointOfSale: {
      restockByDefault: pos?.defaultPosRestock ?? true,
      sendOnlyCompletionEmail: pos?.sendOnlyCompletionEmail ?? true,
      allowAdjustments: pos?.allowPOSAdjustments ?? true,
      allowManualDiscounts: pos?.allowPOSManualDiscounts ?? true,
    },
  };
}

export function pointOfSaleTeamPatch(
  next: PointOfSaleSettings,
): OperationsSettingsPatch {
  return {
    set: {
      "pos.defaultPosRestock": next.pointOfSale.restockByDefault,
      "pos.sendOnlyCompletionEmail": next.pointOfSale.sendOnlyCompletionEmail,
      "pos.allowPOSAdjustments": next.pointOfSale.allowAdjustments,
      "pos.allowPOSManualDiscounts": next.pointOfSale.allowManualDiscounts,
    },
    unset: [],
  };
}
